import {AbstractDTO} from "@signature-it/ngx-generic/models";
import { IFavorites } from "@signature-it/ngx-entity/interfaces";

export class FavoritesDTO extends AbstractDTO implements IFavorites {

    entity_var: string;
    // parentGroupName: string;

    constructor(attributes: Object) {
        super(attributes);
        this.entity_var = attributes['entity_var'] || '';
        // this.productCode = attributes['productCode'] || '';
    }
}
